<style lang="scss" scoped>
.legend {
  width: 100%;
  .legendcontainer {
    display: flex;

    .circlerow {
      display: flex;
      align-items: center;
      // margin: 10px;

      .description {
        position: relative;

        .smdtooltip {
          top: -2px;
        }
      }
    }
  }
  &.right {
    .description {
      margin-left: 10px;
    }
  }
  &.left {
    .description {
      margin-right: 10px;

      .smdtooltip {
        left: -2px;
      }
    }
  }

  .legendtext {
    cursor: pointer;
    text-decoration: underline;
    color: $c-dark-blue;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>

<template>
  <div class="legend" :class="[label]">
    <div class="legendtext" @click="toggleOpen">Legende</div>
    <div class="legendcontainer container-fluid" v-if="open">
      <div class="row"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
// import SkillCircle from './SkillCircle.vue';

export default defineComponent({
  // components: { SkillCircle },
  props: {
    label: { type: String, default: 'right' },
  },
  setup() {
    const open = ref(false);

    const toggleOpen = () => {
      open.value = !open.value;
    };

    return {
      toggleOpen,
      open,
    };
  },
});
</script>
